import {
  SupportTicketFilterNames,
  supportTicketFilterData,
} from "@redotech/effect-api-shared/schema/support-ticket-filters";
import SearchIcon from "@redotech/redo-icons/search-md.svg";
import { ArrayStringFilterOperator } from "@redotech/redo-model/views/advanced-filters/array-string-filter";
import { AdvancedFilterType } from "@redotech/redo-model/views/advanced-filters/generic-advanced-filter-data";
import type { ArrayStringTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

export const WordsAdvancedFilter: ArrayStringTableFilter<string> = {
  type: AdvancedFilterType.ARRAY_TO_STRING,
  Icon: SearchIcon,
  operators: [
    ArrayStringFilterOperator.CONTAINS,
    ArrayStringFilterOperator.NOT_CONTAINS,
  ],
  data: supportTicketFilterData[SupportTicketFilterNames.WORDS],
  itemLabel: "word",
  itemLabelPlural: "words",
  displayName: "Search",
  useSingleSelect: true,
};
